<template>
  <div>
    <sweet-modal ref="modalPin" width="40%">
      <h3>Masukkan Pin Anda Untuk Mengkonfirmasi Transaksi Ini :</h3>
      <el-input
        placeholder="Please input "
        v-model="pin"
        show-password
      ></el-input>

      <vs-button
        class="mr-3"
        vs-align="right"
        vs-justify="right"
        @click="submit"
      >
        Submit
      </vs-button>
      <vs-button
        color="danger"
        class="mt-3"
        vs-align="right"
        vs-justify="right"
        v-on:click="$refs.modalPin.close()"
      >
        Close
      </vs-button>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal, SweetModalTab } from "sweet-modal-vue";

export default {
  name: "ApprovePin",
  components: {
    SweetModal,
    SweetModalTab
  },
  data() {
    return {
      pin: ""
    };
  },
  methods: {
    showModal() {
      this.$refs.modalPin.open();
    },
    async submit() {
      if (this.getBannedValue(this.pin)) {
        this.$vs.notify({
          text: "Pin Required",
          color: "warning",
          title: "WARNING"
        });
        return;
      }
      let cekPin = await this.$$checkPin(this.pin);
      if (cekPin == false) {
        return;
      }
      let list = [];

      if (cekPin.listPermission != null) {
        list = cekPin.listPermission.filter(f => f.menu == "Approval");
      }

      this.$emit("submit", {
        data: cekPin,
        list: list
      });
      this.pin = "";
      this.$refs.modalPin.close();
    }
  }
};
</script>
